import { useLayout } from '@/providers'
import { Drawer, useMediaQuery, useTheme } from '@mui/material'

import SidebarContent from './SidebarContent'

export default function Sidebar() {
	const theme = useTheme()
	const { sidebarWidth, tempSidebarOpen, setTempSidebarOpen } = useLayout()
	const largeScreen = useMediaQuery(theme.breakpoints.up('sm'))

	if (largeScreen)
		return (
			<Drawer
				variant="permanent"
				sx={{
					width: sidebarWidth,
					flexShrink: 0,
					'& .MuiDrawer-paper': {
						overflow: 'hidden',
						width: sidebarWidth,
						boxSizing: 'border-box',
						border: 'none',
						pt: 0,
						transition: theme.transitions.create('width', {
							easing: theme.transitions.easing.sharp,
							duration: theme.transitions.duration.leavingScreen,
						}),
					},
					transition: theme.transitions.create('width', {
						easing: theme.transitions.easing.sharp,
						duration: theme.transitions.duration.leavingScreen,
					}),
				}}
				data-testid="sidebar"
			>
				<SidebarContent />
			</Drawer>
		)

	return (
		<Drawer
			open={tempSidebarOpen}
			variant="temporary"
			onClick={() => setTempSidebarOpen(false)}
			sx={{
				width: sidebarWidth,
				flexShrink: 0,
				'& .MuiDrawer-paper': {
					boxShadow: 3,
					width: sidebarWidth,
					boxSizing: 'border-box',
					border: 'none',
					transition: theme.transitions.create('width', {
						easing: theme.transitions.easing.sharp,
						duration: theme.transitions.duration.leavingScreen,
					}),
				},
				transition: theme.transitions.create('width', {
					easing: theme.transitions.easing.sharp,
					duration: theme.transitions.duration.leavingScreen,
				}),
			}}
			data-testid="sidebar"
		>
			<SidebarContent />
		</Drawer>
	)
}
